import { Breakpoints, BreakpointIdentifier } from './breakpoints'

export const breakpoints: Breakpoints = {
  // These points are based on Bootstrap 4 responsive breakpoints:
  // https://getbootstrap.com/docs/4.1/layout/overview/
  // The important consideration is that we want an accurate breakpoints to
  // detect mobile devices, which is now set to 0-576px wide. Tablet starts
  // at 576px and ends at 992px, beyond which desktop starts.
  // The sub thresholds may be used by exception for more fine-tuning, but
  // mobile, tablet and desktop thresholds should suffice in most instances.
  [BreakpointIdentifier.xs]: 0, // start mobile
  [BreakpointIdentifier.sm]: 576, // landscape phones
  [BreakpointIdentifier.md]: 768, // start tablet
  [BreakpointIdentifier.lg]: 992, // start "desktop" / tablet landscape
  [BreakpointIdentifier.xl]: 1152,
}

export const containerMaxWidths: Breakpoints = {
  [BreakpointIdentifier.xs]: breakpoints.sm - 1,
  [BreakpointIdentifier.sm]: breakpoints.md - 1,
  [BreakpointIdentifier.md]: breakpoints.lg - 1,
  [BreakpointIdentifier.lg]: breakpoints.xl - 1,
  [BreakpointIdentifier.xl]: breakpoints.xl,
}

export const containerOffsetWidths: Breakpoints = {
  [BreakpointIdentifier.xs]: 10,
  [BreakpointIdentifier.sm]: 10,
  [BreakpointIdentifier.md]: 15,
  [BreakpointIdentifier.lg]: 26,
  [BreakpointIdentifier.xl]: 0,
}

export const gridColumns: Breakpoints = {
  [BreakpointIdentifier.xs]: 1,
  [BreakpointIdentifier.sm]: 2,
  [BreakpointIdentifier.md]: 3,
  [BreakpointIdentifier.lg]: 4,
  [BreakpointIdentifier.xl]: 4,
}

export const gridGutterWidths: Breakpoints = {
  [BreakpointIdentifier.xs]: 10,
  [BreakpointIdentifier.sm]: 10,
  [BreakpointIdentifier.md]: 20,
  [BreakpointIdentifier.lg]: 20,
  [BreakpointIdentifier.xl]: 26,
}

export const spacing = {
  x1: 7,
  x2: 14,
  x3: 21,
  x4: 28,
  x5: 35,
  x6: 42,
  x7: 49,
}
